const USER_MANAGEMENT_RECEIVE_ALL_USERS = "USER_MANAGEMENT_RECEIVE_ALL_USERS";
const USER_MANAGEMENT_BEGIN_FETCHING_USERS =
  "USER_MANAGEMENT_BEGIN_FETCHING_USERS";

export default {
  USER_MANAGEMENT_RECEIVE_ALL_USERS,
  USER_MANAGEMENT_BEGIN_FETCHING_USERS
};
